(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kibi-about"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('ka-in'); io.unobserve(e.target);
        if(e.target.hasAttribute('data-ka-stats')) countUp(e.target); } });
    }, {threshold:.18});
    root.querySelectorAll('.ka-reveal').forEach(function(el){ io.observe(el); });
    var stage = root.querySelector('[data-ka-stage]');
    var cards = root.querySelector('[data-ka-cards]');
    if(stage && cards && window.matchMedia('(pointer:fine)').matches){
      stage.addEventListener('mousemove', function(ev){
        var r = stage.getBoundingClientRect();
        var px = (ev.clientX - r.left)/r.width - .5;
        var py = (ev.clientY - r.top)/r.height - .5;
        cards.style.setProperty('--ry', (-14 - px*18).toFixed(1)+'deg');
        cards.style.setProperty('--rx', (6 - py*14).toFixed(1)+'deg');
      });
      stage.addEventListener('mouseleave', function(){ cards.style.removeProperty('--ry'); cards.style.removeProperty('--rx'); });
    }
  }
  function countUp(scope){
    scope.querySelectorAll('[data-count]').forEach(function(el){
      var target = parseInt(el.getAttribute('data-count'),10)||0;
      var suffix = el.getAttribute('data-suffix')||'';
      var start = null, dur = 1400;
      function step(ts){ if(!start) start=ts; var p=Math.min((ts-start)/dur,1);
        var val=Math.floor((1-Math.pow(1-p,3))*target);
        el.textContent = val.toLocaleString('en-IN')+(p>=1?suffix:'');
        if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }
  function boot(){ document.querySelectorAll('[data-kibi-about]').forEach(init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
